<template>
    <a :href="url" class="badge" :class="badgeClass">
        <img :src="imageUrl" :alt="title">
    </a>
</template>

<script>
    export default {
        name: 'Badge',
        props: {
            imageUrl: String,
            url: String,
            title: String,
            more: Boolean
        },
        computed: {
            badgeClass () {
                return this.more ? 'badge--to-earn' : ''
            }
        }
    }
</script>

<style lang="scss" scoped>
    .badge {
        &, > img {
            width: 50px;
            height: 50px;
        }

        &--to-earn {
            &, > img {
                width: 30px;
                height: 30px;
            }

            opacity: 0.25;
            transition: opacity 0.1s ease-in-out;

            &:hover {
                opacity: 0.5;
            }
        }
    }
</style>